import { em } from 'polished'
import styled from 'styled-components'

export const ImageWrapper = styled.div`
  position: absolute;
  width: ${em(320)};
  right: 0;

  ${p => p.theme.mq.upMd} {
    width: ${em(237)};
    top: ${em(-160)};
    left: 0;
    margin: auto;
  }
`

export const ImageBox = styled.div`
  min-height: ${em(100)};

  ${p => p.theme.mq.upMd} {
    min-height: ${em(360)};
  }
`

export const Line = styled.div`
  display: none;

  ${p => p.theme.mq.upLg} {
    display: block;
    position: absolute;
    width: ${em(177)};
    height: ${em(140)};
    top: 0;
    bottom: 0;
    left: ${em(42)};
    right: 0;
    margin: auto;
    transform: translate(${em(-140)}, ${em(-65)});
  }

  svg {
    overflow: visible !important;
    width: 100%;
    height: 100%;
  }
`
